// AudioController.jsx
import { useState, useEffect, useRef } from 'react'
import { useThree } from '@react-three/fiber'

export default function AudioController({ url = '/audio/santatellme.mp3' }) {
  const [isPlaying, setIsPlaying] = useState(true)  // start with music on
  const audioRef = useRef(null)

  useEffect(() => {
    audioRef.current = new Audio(url)
    audioRef.current.loop = true
    audioRef.current.volume = 0.4  // gentle volume

    if (isPlaying) {
      audioRef.current.play().catch(e => {
        console.log("Audio play failed (user didn't interact yet):", e)
        setIsPlaying(false)  // many browsers block autoplay until user interacts
      })
    }

    return () => {
      audioRef.current?.pause()
      audioRef.current = null
    }
  }, [url])

  useEffect(() => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.play()
      } else {
        audioRef.current.pause()
      }
    }
  }, [isPlaying])

  const toggle = () => setIsPlaying(prev => !prev)

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 100,
      background: 'rgba(0,0,0,0.5)',
      padding: '12px 16px',
      borderRadius: '50px',
      cursor: 'pointer',
      userSelect: 'none',
      fontFamily: 'sans-serif',
      color: 'white',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    }} onClick={toggle}>
      {isPlaying ? '🔇' : '🔊'} 
      {isPlaying ? 'Music Off' : 'Music On'}
    </div>
  )
}